import { Flex, Input } from 'antd';
import { Filter, Form } from 'components';
import type { Paths } from 'type-fest';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import { CommoditiesSelect } from '@/components/form/select/CommoditiesSelect';
import { ManufacturersSelect } from 'components/form/select/ManufacturersSelect';
import {
  DEFAULT_FILTER,
  type CompatibleModelsFilterShape,
  useCompatibleModelsFilterWithPagination,
} from '../hooks/useMeterModelsFilterWithPagination';

export const MeterModuleCompatibleModelsFilter = () => {
  const [form] = Form.useForm<CompatibleModelsFilterShape>();
  const selectedCommodity = Form.useWatch('commodity', form);

  const { filter, setFilterState, resetFilterState, setPaginationState } = useCompatibleModelsFilterWithPagination();

  const handleReset = () => {
    form.setFieldsValue(DEFAULT_FILTER);

    resetFilterState();
    setPaginationState({
      current: 1,
    });
  };
  return (
    <Filter form={form} initialValues={filter} onFinish={setFilterState}>
      <Form.Item label="Search" name={'search' satisfies Paths<CompatibleModelsFilterShape>}>
        <Input allowClear placeholder="Search model" />
      </Form.Item>

      <Form.Item label="Commodity" name={'commodity' satisfies Paths<CompatibleModelsFilterShape>}>
        <CommoditiesSelect />
      </Form.Item>

      <Form.Item label="Manufacturer" name={'manufacturerId' satisfies Paths<CompatibleModelsFilterShape>}>
        <ManufacturersSelect
          allowClear
          maxTagCount="responsive"
          maxTagTextLength={20}
          commodity={selectedCommodity}
          placeholder="Select manufacturer"
        />
      </Form.Item>

      <Flex align="end" flex={2} justify="space-between">
        <FilterControlButtons onClickReset={handleReset} />
      </Flex>
    </Filter>
  );
};
